import React from 'react';
import DataLayer from '../../../utils/gtm/DataLayer';
import Button from '@mui/material/Button';

const MobileSignInButtons = () => {
  return (
    <>
      <div className="home-drawer-actions">
        <Button
          variant="contained"
          className="thunderbird nav-menu-button"
          href="/members/sign_up"
          onClick={() =>
            DataLayer.sendAnalyticsEvent({
              category: 'Interaction',
              action: 'Button Click',
              label: 'Red Top Nav Button',
            })
          }
        >
          Join PCSgrades
        </Button>

        <Button
          variant="contained"
          className="brand-blue nav-menu-button"
          href="/sign_in"
        >
          Log In
        </Button>
      </div>
    </>
  );
};

export default MobileSignInButtons;
